import produce from "immer";

import { ModelState } from "../../../interfaces/modelState";

interface PhoneNumberMutationModel {
  oldPhoneNumber?: string;
  newPhoneNumber: string;
}

interface State {
  data: Partial<PhoneNumberMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    oldPhoneNumber: undefined,
    newPhoneNumber: undefined,
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_PHONE_NUMBER_MUTATION_DATA"; payload: Partial<PhoneNumberMutationModel> }
  | { type: "UPDATE_PHONE_NUMBER_MUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_PHONE_NUMBER_MUTATION_FETCH_START" }
  | { type: "UPDATE_PHONE_NUMBER_MUTATION_FETCH_ERROR"; payload: ModelState };

export const phoneNumberMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_PHONE_NUMBER_MUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_PHONE_NUMBER_MUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_PHONE_NUMBER_MUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_PHONE_NUMBER_MUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
